import { Injectable, Renderer2 } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { combineLatest, filter, map, of, tap } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { WebchatService } from '../webchat/webchat.service';
import { ServiceWorkerService } from '../service-worker/service-worker.service';
import { AnalyticsService } from '../analytics/analytics.service';
import { Utility } from '@global/infrastructure/helpers/utility';
import {
  selectPolicyId as policyIdMTA,
  selectSource as sourceMTA,
} from '@app/stp/state/selectors';
import { selectSource as sourceRen } from '@ren/main/state/selectors/policy.selectors';
import { selectPolicyId as policyIdRen } from '@ren/main/state/selectors/renewal.selectors';

@Injectable({
  providedIn: 'root',
})
export class PostNavigationService {
  renderer: Renderer2;
  private readonly isMTA = Utility.isMta();
  service: { selectRootElement: any; };

  constructor(
    private readonly router: Router,
    private readonly webchatService: WebchatService,
    private readonly store: Store<{}>,
    private readonly serviceWorkerService: ServiceWorkerService,
    private readonly analyticsService: AnalyticsService
  ) {}

  onNavigate() {
    if (window.location.href.includes('dashboard/change-type')) return of('');
    const selectSource = this.store.pipe(
      select(this.isMTA ? sourceMTA : sourceRen)
    );
    const selectPolicyId = this.store.pipe(
      select(this.isMTA ? policyIdMTA : policyIdRen)
    );

    return combineLatest([
      this.router.events.pipe(filter((evt) => evt instanceof NavigationEnd)),
      selectSource,
      selectPolicyId,
    ]).pipe(
      tap(([event, salesChannel, policyId]) => {
        this.focusFirstElement();
        Utility.generateButtonIds();
        sessionStorage.removeItem('lastErrorMessage');
        this.trackPage();
        this.webchatService.trackSectionTags({
          event,
          salesChannel,
          policyId,
        });
      }),
      tap(() => this.serviceWorkerService.appUpdateCheck()),
      map(([navEnd]) => {
        this.serviceWorkerService.appApplyUpdate();
        return (navEnd as NavigationEnd).url;
      })
    );
  }

  private focusFirstElement(): void {
    setTimeout(() => {
      const resetFocus = document.getElementById('resetFocus');
      if (resetFocus) {
        this.renderer.selectRootElement(resetFocus).focus();
      }
    });
  }

  private trackPage(): void {
    this.analyticsService.trackPage();
    const pathName = window.location.pathname.split('/');

    if (window.hasOwnProperty('utag')) {
      if (
        this.isMTA &&
        pathName.indexOf('premium') === -1 &&
        !(pathName.indexOf('dashboard') > -1 && pathName.indexOf('select') > -1)
      ) {
        window.utag?.view();
      }
      if (this.isMTA === false && pathName.indexOf('review') === -1) {
        window.utag?.view();
      }
    }
  }
}
